export function debugLog( message: string ): void {
    // eslint-disable-next-line no-console
    console.log( message );
}
export function calculateScrollbarWidth() {
    const div = document.createElement("div");
    div.style.width = "100px";
    div.style.height = "100px";
    div.style.overflowY = "scroll";
    div.style.position = "absolute";
    div.style.top = "-9999px";
    document.body.appendChild(div);

    const scrollbarWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
}
